export const FIELD_BOTTOM_INDENT = { marginBottom: '12px' }
export const DEFAULT_BOTTOM_INDENT = { marginBottom: '20px' }
export const LARGE_BOTTOM_INDENT = { marginBottom: '24px' }
